import axios from 'axios'
import {API} from './url/index'

export default {
  getSummary: function(days, successFn, errorFn) {
    axios.get(API.analytics.summary, { params: { days: days || 30 } })
      .then(function(res) { successFn(res.data) })
      .catch(function(e) {
        errorFn((e.response && e.response.data && e.response.data.message) || 'Failed to load analytics')
      })
  }
}
